<template>
<div style="width: 100%">
  <headers2 :title="titles"></headers2>

  <div class="contentBox">

   <div class="content">
     <div class="mzsm">
       <el-button type="primary" size="small" @click="toMzsm">免责声明</el-button>
     </div>

     <el-card class="box-card"  v-if="!isMore">
       <div class="policy lines seemores">
         <el-button class="seeMore poin" type="text" plain round size="mini" @click="toSeeMore('2')">更多 ></el-button>
         <el-tabs v-model="activeName" type="border-card"  >
           <el-tab-pane label="国家知识产权局地理标志保护产品批准公告" name="first">
             <div class="policyAnswersItem" v-for="(item,index) in policyAnswersData['2']" :key="index" @click="toDetails(item)">
               <span class="child1">{{item.name }}</span>
               <span class="child1">{{item.coding}}</span>
             </div>
           </el-tab-pane>
         </el-tabs>
       </div>
       <div class="policy lines seemores">
         <el-button class="seeMore poin" type="text" plain round size="mini" @click="toSeeMore('1')">更多 ></el-button>
         <el-tabs v-model="activeName" type="border-card">
           <el-tab-pane label="原质监总局地理标志保护产品批准公告" name="first">
             <div class="policyAnswersItem" v-for="(item,index) in policyAnswersData['1']" :key="index" @click="toDetails(item)">
               <span class="child1">{{item.name}}</span>
               <span class="child1">{{item.coding}}</span>
             </div>
           </el-tab-pane>
         </el-tabs>
       </div>
     </el-card>


     <el-card class="box-card" v-if="isMore">
       <div class="policy lines seemores">
         <el-form :inline="true" label-width="100px" :model="formInline" class="demo-form-inline">
           <el-form-item  >
             <el-input v-model = "formInline.name" placeholder="关键词搜索" class="width1"></el-input>
           </el-form-item>
           <el-form-item label="">
             <el-button type="primary"   class=" btn1" @click="handleSearch" >查询</el-button>
           </el-form-item>
         </el-form>
         <div class="policyAnswersItem" v-for="(item,index) in moreData" :key="index" @click="toDetails(item)">
           <span class="child1">{{item.name }}</span>
           <span class="child1">{{item.coding}}</span>
         </div>

         <div class="pagination_box">
           <el-pagination layout="total,prev, pager, next" v-if="total >0" :page-size="formInline.limit"   @current-change="handleCurrentChange" :total="total"></el-pagination>
         </div>
       </div>
     </el-card>

   </div>
  </div>


  <el-dialog
    title="免责声明"
    :visible.sync="dialogVisible"
    :show-close="false"
    :center="true"
    width="50%">
    <div class="title">使用说明</div>
    <div class="text">本栏目为社会公众提供地理标志产品信息检索，本系统的数据信息并非实时更新，有一定滞后性，仅供参考，不具有法律效力，以国家知识产权局官方公告信息为准。</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">我接受</el-button>
    </span>
  </el-dialog>


  <footers></footers>
</div>
</template>

<script>
import headers2 from "../../../comm/components/headers2.vue";
import pos_top1 from  "../../../comm/components/pos_title_top.vue"
import footers from '@comm/components/footers.vue'
import {moreList, searchInit} from "../../api/query";
export default {
  name: "index",
  components:{
    headers2,pos_top1,footers
  },
  data(){
    return{
      isMore:false,
      total:0,
      formInline:{
        name:'',
        type:'',
        limit:10,
        page:'1',
      },
      moreData:[],
      titles:'地理标志产品检索',
      dialogVisible:false,
      activeName:'first',
      policyAnswersData:{},


    }
  },

  created() {
    // this.dialogVisible = true

  },

  mounted() {
   this.getData()
  },


  methods:{

    //查询
    handleSearch(){
      this.formInline.page = 1

      this.getList()

    },

    getList(){
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      moreList(this.formInline).then(res=>{
        if(res.errorCode == 200){
          loading.close()
          this.moreData = res.data.data
          this.total = res.data.count
        }

      })
    },

    //初始化数据
    getData(){
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      searchInit().then(res=>{
        if (res.errorCode  == 200){
          loading.close()
          this.policyAnswersData = res.data
        }

      })
    },
    //免责声明
    toMzsm(){

      this.dialogVisible = true

    },

    // 分页
    handleCurrentChange(pageIndex) {
      this.formInline.page = pageIndex;
      this.getList()
    },



    //更多
    toSeeMore(index){
      this.formInline.type = index
      this.isMore = true
      this.handleSearch()

    },
    //详情
    toDetails(item){
        let urls1 = window.location.origin  +'/dlbzsq' + '/detail'   + '?id=' + item.id + '&name=' + item.name;
        window.open(urls1 ,'_blank')//详情页

    },
  }
}
</script>
<style lang="less">
.seemores > .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  font-size: 1rem;
  font-weight: bold;
}
</style>

<style scoped lang="less">

.contentBox{
 width: 100%;
  min-height: 100vh-40rem;
  display: flex;
  justify-content: center;


  .content{
    display: block;
    width: 75rem;
    .mzsm{
      text-align: right;
      margin-bottom: 0.875rem;
    }
  }

}
.title{
  font-weight: bold;
  font-size: 1.25rem;
}
.text{
  margin-top: 1.25rem;
  text-indent: 2em;
  line-height: 2rem;
  font-size: 1rem;
}

.policy{
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  background: rgb(255, 255, 255);
  padding:1rem;
}

.lines .el-tabs__nav-wrap::after{
  background: none;
}
.lines .el-tabs__item.is-active{
  font-size: 1.25rem;
  color: rgb(27, 61, 109);

}
.lines .el-tabs__item{
  font-size: 1.25rem;
  color: rgb(186, 196, 211);
}

.seemores .el-tabs__header{
  width: 30% !important;
  background: #ff6700;

}


.seemores {
  position: relative;
  .seeMore{
    position: absolute;
    font-size: 14px;
    right:30px;
    top: 1.3rem;
    z-index: 999999;
    cursor: pointer;
  }

}
.add-button {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
}
.policyAnswersItem{
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  color: rgb(27, 61, 109) ;
  height: 2rem;
  align-items: center;
  margin-bottom: 10px;
  box-sizing: border-box;
  border-bottom: 1px dashed rgb(186, 196, 211);

}
.policyAnswersItem:hover{
  border-bottom: 1px dashed rgb(17, 144, 222);

}
.policyAnswersItem:hover  .child1{
  color: rgb(17, 144, 222) ;

}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/dbQuery/index.vue